
import React, { FC } from 'react';
import styled, { css } from '@emotion/native'
import Text from '@components/1-atoms/Text';

const Container = styled.TouchableOpacity`
color: ${({ theme }: any) => `${theme.colors.gray_1}`};
display: flex;
flex-direction: row;
padding: 9px;
justify-content: center;
align-items: center;

border-radius: 6px;
`;

const IconButton: FC<IconButtonProps> = ({ onPress, transparent = true, children, color, icon, ...props }) => {
  const background  = transparent ?  null : css(`background-color: rgba(0, 0, 0, 0.25);`)

  return (
    <Container style={background} onPress={onPress} {...props}>
      {icon}<Text bold color={color}>{children}</Text>
    </Container>
  );
};

type IconButtonProps = {
  onPress?: () => void;
  transparent?: boolean;
  children?: React.ReactNode;
  color?: string;
  icon?: React.ReactNode;
};

export default IconButton;